import { inject, Injectable, signal } from '@angular/core';
import { getCurrentUser } from '@aws-amplify/auth';
import { APIService } from './api';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private api = inject(APIService);
  private spinner = inject(NgxSpinnerService);

  user = signal<any>(null);

  constructor() {
    this.getUser();
  }

  getUser = async () => {
    try {
      this.spinner.show();

      const { userId } = await getCurrentUser();

      const userDetails = await this.api.ListUserDetails(
        { userID: { eq: userId } },
        10000,
      );

      this.user.set(userDetails.items?.[0] ?? {});
    } catch (error) {
      // User is not authenticated - set user to null
      this.user.set(null);
    } finally {
      this.spinner.hide();
    }
  };

  createUser = async (form: any) => {
    this.spinner.show();

    const { userId } = await getCurrentUser();

    const street = form.get('street')?.value ?? '';
    const postalCode = form.get('postalCode')?.value ?? '';
    const city = form.get('city')?.value ?? '';
    const province = form.get('province')?.value ?? '';
    const country = form.get('country')?.value ?? 'Italia';
    const sdiCode = form.get('sdiCode')?.value ?? '';
    const hasAddressData = street || city || postalCode;
    const addressValue = hasAddressData
      ? JSON.stringify({ street, postalCode, city, province, country, sdiCode })
      : (form.get('address')?.value ?? '');

    await this.api.CreateUserDetails({
      userID: userId,
      id: form.get('id')?.value ?? '',
      name: form.get('name')?.value ?? '',
      surname: form.get('surname')?.value ?? '',
      phoneNumber: form.get('phoneNumber')?.value ?? '',
      companyRole: form.get('companyRole')?.value ?? '',
      companyName: form.get('companyName')?.value ?? '',
      vatNumber: form.get('vatNumber')?.value ?? '',
      address: addressValue,
      businessSector: form.get('businessSector')?.value ?? '',
      otherBusinessSector: form.get('otherBusinessSector')?.value ?? '',
      numberOfEmployees: Number(form.get('numberOfEmployees')?.value ?? 0),
      profilePhoto: form.get('profilePhoto')?.value ?? '',
      pec: form.get('pec')?.value ?? '',
      legalRepresentative: form.get('legalRepresentative')?.value ?? '',
    });

    this.getUser();
  };

  updateUser = async (form: any) => {
    this.spinner.show();

    const { userId } = await getCurrentUser();

    const street = form.get('street')?.value ?? '';
    const postalCode = form.get('postalCode')?.value ?? '';
    const city = form.get('city')?.value ?? '';
    const province = form.get('province')?.value ?? '';
    const country = form.get('country')?.value ?? 'Italia';
    const sdiCode = form.get('sdiCode')?.value ?? '';
    const hasAddressData = street || city || postalCode;
    const addressValue = hasAddressData
      ? JSON.stringify({ street, postalCode, city, province, country, sdiCode })
      : (form.get('address')?.value ?? '');

    await this.api.UpdateUserDetails({
      userID: userId,
      id: form.get('id')?.value ?? '',
      name: form.get('name')?.value ?? '',
      surname: form.get('surname')?.value ?? '',
      phoneNumber: form.get('phoneNumber')?.value ?? '',
      companyRole: form.get('companyRole')?.value ?? '',
      companyName: form.get('companyName')?.value ?? '',
      vatNumber: form.get('vatNumber')?.value ?? '',
      address: addressValue,
      businessSector: form.get('businessSector')?.value ?? '',
      otherBusinessSector: form.get('otherBusinessSector')?.value ?? '',
      numberOfEmployees: Number(form.get('numberOfEmployees')?.value ?? 0),
      profilePhoto: form.get('profilePhoto')?.value ?? '',
      pec: form.get('pec')?.value ?? '',
      legalRepresentative: form.get('legalRepresentative')?.value ?? '',
    });

    this.getUser();
  };
}
